import classnames from "classnames";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { Link } from "react-router-dom";

import { DialogSection } from "./DialogSection";
import { T } from "../../../util/t";
import { SHORT_DATE } from "utils/dates";
import { makeStyles } from "components/providers/makeStyles";
import { useLocalizationContext } from "components/providers/LocalizationProvider";
import { useLocation } from "react-router-dom";

const formatters = {
    date: value => dayjs(value).format(SHORT_DATE),
    checkbox: (value, translate) => value ? translate("Yes") : translate("No")
};

const getPropertyValue = (item, property, translate = v => v) => {
    let value = item?.getIn(["properties", property.uuid, "value"]);
    if (value != null && formatters[property.type]) value = formatters[property.type](value, translate);
    return value;
};

export const mapProperties = (item, translate) => property =>
    ({ uuid: property.uuid, type: property.type, label: property.label, value: getPropertyValue(item, property, translate) });

const join = array => array.filter(v => v).join(", ");

const useStyles = makeStyles((theme) => ({
    section: {
        "&&": {
            marginTop: 0,
        }
    }
}));

export const AthleteDetails = ({ athlete, title, athleteProperties = [], userProperties = [], isTeams }) => {
    const { translate } = useLocalizationContext();
    const athletePropertyMapper = mapProperties(athlete, translate);
    const users = athlete.get("users", []);
    const classes = useStyles();
    const { pathname } = useLocation();

    return (
        <DialogSection
            className={classnames(!isTeams && classes.section)}
            title={title || "Athlete details"}
            action={
                <Button to={{ pathname: `/athletes/${athlete.get("id")}`, state: { from: pathname } }} component={Link} startIcon={<Visibility fontSize="small"/>}>
                    <T>View</T>
                </Button>
            }
            fields={[
                { label: "Name", value: athlete.get("name") },
                !isTeams && { label: "Date of birth", value: athlete.get("dob") && dayjs(athlete.get("dob")).format(SHORT_DATE) },
                ...athleteProperties.map(athletePropertyMapper),
                { label: "Email", value: join(users.map(user => user.get("email"))) },
                { label: "Contact phone number", value: join(users.map(user => user.get("phone"))) },
                ...userProperties.map(property =>
                    ({ uuid: property.uuid, label: property.label, value: join(users.map(user => getPropertyValue(user, property, translate))) })
                ),
            ].filter(f => f)}
        />
    );
};
